<style scoped>
    .scheduleCheckbox {
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .scheduleHeader {
        cursor: pointer;
        margin: 4px;
    }

    table {
        border: none;
    }

    .btn {
        margin: 5px;
    }

    .pattern-button {
        width: 120px
    }
</style>
<template>
    <div style="padding:10px;width:auto; padding: 10px !important;    border: 2px solid #dce4ec;">
        <table>
            <tbody>
                <tr>
                    <td width="auto">
                        <h4 v-if="currentPattern=='P'" class="text-warning"><i class="fa fa-check-circle"></i>&nbspPRN Active</h4>
                        <table>
                            <tr>
                                <th>
                                    <button class="btn btn-xs btn-info" @click="SelectAll()" :disabled="currentPattern=='P'" ><i class="fa fa-tasks pull-right scheduleHeader"  /> All</button>
                                </th>
                                <th v-for="(day,dindex) in days" class="text-success scheduleHeader text-center">
                                    <button @click.prevent="SelectDay(dindex)" class="btn btn-info btn-xs text-center"  :disabled="currentPattern=='P'">{{day}}</button>
                                </th>
                            </tr>
                            <tr v-for="(week,windex) in weeks">
                                <td class="text-success scheduleHeader">
                                    <button @click.prevent="SelectWeek(windex)" class="btn btn-info btn-xs text-center" :disabled="currentPattern=='P'">{{week}}</button>
                                </td>
                                <td v-for="(day,dindex) in days">
                                    <input class="scheduleCheckbox text-center" type="checkbox" v-model="selection[(windex)*7 + (dindex)]" @change="Encode()"  :disabled="currentPattern=='P'"/>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td>
                        <button v-if="currentPattern=='P'" class="btn btn-sm btn-primary pattern-button" @click.prevent.stop="SetPattern('1')">Disable PRN</button>
                        <button v-if="currentPattern!='P'" class="btn btn-sm btn-primary pattern-button" @click.prevent.stop="SetPattern('P')">Set PRN</button><br />
                        <button class="btn btn-sm btn-light pattern-button" @click.prevent.stop="SetPattern('1')">Every Day</button><br />
                        <button class="btn btn-sm btn-light pattern-button" @click.prevent.stop="SetPattern('10')">Every Second Day</button><br />
                        <button class="btn btn-sm btn-light pattern-button" @click.prevent.stop="SetPattern('100')">Every Third Day</button><br />
                        <button class="btn btn-sm btn-light pattern-button" @click.prevent.stop="SetPattern('1000')">Every Fourth Day</button><br />

                    </td>
                </tr>
            </tbody>
        </table>

    </div>
</template>
<script>
    import moment from 'moment';

    export default {
        props: ['controller', 'startDate'],
        data: function () {
            return {
                weekdays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                days: [],
                weeks: ["Week 1 ", "Week 2 ", "Week 3 ", "Week 4 "],
                selection: [],
                currentPattern: ""
            }
        },
        watch: {
            'controller.value': function (val) {
                console.log("Schedule changed on Selector", this.value, val)
                if (this.value != this.currentPattern) {
                    this.selection = this.Decode(this.controller.value)
                    //this.Encode();
                }
            }
        },
        mounted() {
            var dayOfWeek = moment(this.startDate).day();

            for (var i = 0; i < 7; i++) {
                var index = dayOfWeek + i;
                if (index > 6) {
                    index = index - dayOfWeek - 1;
                }
                this.days.push(this.weekdays[index]);
            }

            //this.selection = [];
            for (var w = 0; w < 4; w++) {
                for (var d = 0; d < 7; d++) {
                    this.selection.push(false);
                }
            }

            this.selection = this.Decode(this.controller.value)
            //this.currentPattern = this.value;
            this.currentPattern = this.controller.value;
            //this.Encode();
        },
        methods: {
            Encode() {
                var matches = (p, s) => this.Decode(p).join('') == this.selection.join('');
                var pattern = this.selection.map(s => s ? "1" : "0");
                var matchingLength = 0;

                while (pattern.length > 0) {
                    //console.log("Pattern Match : " + pattern + " : " + matches(pattern, this.selection))
                    if (matches(pattern, this.selection)) {
                        matchingLength = pattern.length;
                    };

                    pattern = this.selection.slice(0, pattern.length - 1);
                }

                var result = this.selection.slice(0, matchingLength).map(p => p ? "1" : "0").join('');
                if (result != this.value) {
                    this.currentPattern = result;
                    //this.$emit('input', result);
                    this.controller.value = result;
                }

            },
            SetPattern(pattern) {
                this.selection = this.Decode(pattern);
                if (pattern != this.value) {
                    this.currentPattern = pattern;
                    //this.$emit('input', pattern);
                    this.controller.value = pattern;
                }

            },
            Decode(str) {
                
                var result = [];
                while (result.length < 28) {
                    for (var item of str) {
                        result.push(item);
                    }
                }

                return result.slice(0, 28).map(r => r == 1)
            },


            SelectWeek(windex) {
                console.log("Setting week " + windex + " to true")
                var containsSelection = false;
                for (var d = 0; d < 7; d++) {
                    if (this.selection[windex * 7 + d]) {
                        containsSelection = true;
                        break
                    }
                }

                for (var d = 0; d < 7; d++) {
                    this.$set(this.selection, windex * 7 + d, !containsSelection);
                }
            },
            SelectDay(dindex) {
                console.log("Setting week " + windex + " to true")
                var containsSelection = false;
                for (var windex = 0; windex < 4; windex++) {
                    if (this.selection[(windex + 1) * 7 + dindex]) {
                        containsSelection = true;
                        break
                    }
                }
                for (var windex = 0; windex < 4; windex++) {
                    this.$set(this.selection, (windex) * 7 + dindex, !containsSelection);
                }
                this.Encode();
            },
            SelectAll() {
                var containsSelection = false;
                for (var windex = 0; windex < 4; windex++) {
                    for (var dindex = 0; dindex < 7; dindex++) {
                        if (this.selection[(windex) * 7 + dindex]) {
                            containsSelection = true;
                            break
                        }
                    }
                }
                for (var i = 0; i < 28; i++) {
                    this.$set(this.selection, i, !containsSelection);
                }
                this.Encode();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ScheduleSelector.scp.html?581ae71d